//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;
    disabledOn : string ;
    disabled : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
                this.disabledOn = null;
                this.disabled = false ;
        }
}

export class SyncConfig extends BaseEntity {
    webUserId : string;
    isSyncEnabled : boolean;
    lastSyncedOn : string ;
    nextSyncOn : string ;
    googleCalendarsToSync : NameId[];
    useDedicatedCalendar : boolean;
    dedicatedCalendarName : string;
    previousMonthsToSync : number;
    afterMonthsToSync : number;
    syncFrequency : number;
    syncFromOnOfficeToGoogle : boolean;
    syncFromGoogleToOnOffice : boolean;
    resourcesMap : NameIdResourcePair[];
    groupsMap : GroupsPair[];
    usersMap : UsersPair[];
    useCalendarsAsUsers : boolean;
    useOnOfficeServiceSpecialUser : boolean;
    mapOnOfficeServiceSpecialUser : GetUserByEmailResponse;
    vonUsersMap : VonUserNameIdPair[];
    createNewAddressTask : boolean;
    writeAddressesInNotes : boolean;
    sendNotificationsOnUpdates : boolean;
    sendNotificationsOnCreation : boolean;
    writeEstateInNotes : boolean;

    constructor() 
    {
    	        super();
		            this.webUserId = "" ;
                this.isSyncEnabled = false ;
                this.lastSyncedOn = null;
                this.nextSyncOn = null;
                this.googleCalendarsToSync = [];
                this.useDedicatedCalendar = false ;
                this.dedicatedCalendarName = "" ;
                this.previousMonthsToSync = null ;
                this.afterMonthsToSync = null ;
                this.syncFrequency = null ;
                this.syncFromOnOfficeToGoogle = false ;
                this.syncFromGoogleToOnOffice = false ;
                this.resourcesMap = [];
                this.groupsMap = [];
                this.usersMap = [];
                this.useCalendarsAsUsers = false ;
                this.useOnOfficeServiceSpecialUser = false ;
                this.mapOnOfficeServiceSpecialUser = new GetUserByEmailResponse();
                this.vonUsersMap = [];
                this.createNewAddressTask = false ;
                this.writeAddressesInNotes = false ;
                this.sendNotificationsOnUpdates = false ;
                this.sendNotificationsOnCreation = false ;
                this.writeEstateInNotes = false ;
        }
}

export class NameId {
    name : string;
    id : string;

    constructor() 
    {
    	            this.name = "" ;
                this.id = "" ;
        }
}

export class NameIdResourcePair {
    nameId : NameId;
    keyValue : { [key: string]: string; };
    isCalendar : boolean;

    constructor() 
    {
    	            this.nameId = new NameId();
                this.keyValue = {};
                this.isCalendar = false ;
        }
}

export class GroupsPair {
    onOfficeGroupId : number;
    onOfficeName : string;
    onOfficeUserIds : number[];
    googleName : string;
    googleEmails : string[];

    constructor() 
    {
    	            this.onOfficeGroupId = null ;
                this.onOfficeName = "" ;
                this.onOfficeUserIds = [];
                this.googleName = "" ;
                this.googleEmails = [];
        }
}

export class UsersPair {
    onOfficeUser : GetUserByEmailResponse;
    googleEmail : string;

    constructor() 
    {
    	            this.onOfficeUser = new GetUserByEmailResponse();
                this.googleEmail = "" ;
        }
}

export class GetUserByEmailResponse {
    vorname : string;
    nachname : string;
    name : string;
    email : string;
    nr : string;

    constructor() 
    {
    	            this.vorname = "" ;
                this.nachname = "" ;
                this.name = "" ;
                this.email = "" ;
                this.nr = "" ;
        }
}

export class VonUserNameIdPair {
    vonUser : GetUserByEmailResponse;
    googleCalendar : NameId;

    constructor() 
    {
    	            this.vonUser = new GetUserByEmailResponse();
                this.googleCalendar = new NameId();
        }
}

export class SyncStateSummary {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;
    userIds : OnOfficeUserIds;
    eventsCount : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
                this.userIds = new OnOfficeUserIds();
                this.eventsCount = null ;
        }
}

export class OnOfficeUserIds {
    userId : string;
    webUserId : string;
    username : string;

    constructor() 
    {
    	            this.userId = "" ;
                this.webUserId = "" ;
                this.username = "" ;
        }
}

export class SyncState extends BaseEntity {
    userIds : OnOfficeUserIds;
    eventIdPair : EventIdPair[];

    constructor() 
    {
    	        super();
		            this.userIds = new OnOfficeUserIds();
                this.eventIdPair = [];
        }
}

export class EventIdPair {
    onOfficeId : number;
    googleId : string;
    eventOrigin : string;
    eventCalendarId : string;
    googleLastModified : string ;
    onOfficeLastModified : string ;
    status : string;

    constructor() 
    {
    	            this.onOfficeId = null ;
                this.googleId = "" ;
                this.eventOrigin = "" ;
                this.eventCalendarId = "" ;
                this.googleLastModified = null;
                this.onOfficeLastModified = null;
                this.status = "" ;
        }
}

export class ReadCalendarEvent {
    start_dt : string ;
    end_dt : string ;
    description : string;
    note : string;
    ort : string;
    art : { [key: string]: string; };
    fuer : string[];
    groups : string[];
    emails : any;
    user_ids : number[];
    ressources : string[];
    ressourcesWithKeys : any;
    erinnerung : string;
    ganztags : boolean;
    rp_flag : boolean;
    abgesagt : boolean;
    assignedaddressids : number[];
    status : string;
    confirmationStatus : string;
    addresses : CalendarAddress[];
    assignedobjectids : number[];
    rp_type : string;
    rp_tage : number;
    rp_beginn_datum : string;
    rp_ende_datum : string;
    rp_ende_status : string;
    allowTransitTime : boolean;
    transitTime : string;
    transitTimePre : string;
    transitTimePost : string;
    rp_exception : string[];
    projektNr : number;
    von : string;
    private : string;
    modified : string ;
    users : CalendarUser[];

    constructor() 
    {
    	            this.start_dt = null;
                this.end_dt = null;
                this.description = "" ;
                this.note = "" ;
                this.ort = "" ;
                this.art = {};
                this.fuer = [];
                this.groups = [];
                this.emails = null;
                this.user_ids = [];
                this.ressources = [];
                this.ressourcesWithKeys = null;
                this.erinnerung = "" ;
                this.ganztags = false ;
                this.rp_flag = false ;
                this.abgesagt = false ;
                this.assignedaddressids = [];
                this.status = "" ;
                this.confirmationStatus = "" ;
                this.addresses = [];
                this.assignedobjectids = [];
                this.rp_type = "" ;
                this.rp_tage = null ;
                this.rp_beginn_datum = "" ;
                this.rp_ende_datum = "" ;
                this.rp_ende_status = "" ;
                this.allowTransitTime = false ;
                this.transitTime = "" ;
                this.transitTimePre = "" ;
                this.transitTimePost = "" ;
                this.rp_exception = [];
                this.projektNr = null ;
                this.von = "" ;
                this.private = "" ;
                this.modified = null;
                this.users = [];
        }
}

export class CalendarAddress {
    id : number;
    confirmationStatus : string;

    constructor() 
    {
    	            this.id = null ;
                this.confirmationStatus = "" ;
        }
}

export class CalendarUser {
    id : string;
    username : string;
    firstName : string;
    lastName : string;
    email : string;

    constructor() 
    {
    	            this.id = "" ;
                this.username = "" ;
                this.firstName = "" ;
                this.lastName = "" ;
                this.email = "" ;
        }
}

export class Event {
    /** Whether anyone can invite themselves to the event (deprecated). Optional. The default is False. */
    anyoneCanAddSelf : boolean;
    /** File attachments for the event. In order to modify attachments the supportsAttachments request parameter
should be set to true. There can be at most 25 attachments per event, */
    attachments : EventAttachment[];
    /** The attendees of the event. See the Events with attendees guide for more information on scheduling events
with other calendar users. Service accounts need to use domain-wide delegation of authority to populate the
attendee list. */
    attendees : EventAttendee[];
    /** Whether attendees may have been omitted from the event's representation. When retrieving an event, this may
be due to a restriction specified by the maxAttendee query parameter. When updating an event, this can be
used to only update the participant's response. Optional. The default is False. */
    attendeesOmitted : boolean;
    /** The color of the event. This is an ID referring to an entry in the event section of the colors definition
(see the  colors endpoint). Optional. */
    colorId : string;
    /** The conference-related information, such as details of a Google Meet conference. To create new conference
details use the createRequest field. To persist your changes, remember to set the conferenceDataVersion
request parameter to 1 for all event modification requests. */
    conferenceData : ConferenceData;
    /** Creation time of the event (as a RFC3339 timestamp). Read-only. */
    created : string;
    /** The creator of the event. Read-only. */
    creator : CreatorData;
    /** Description of the event. Can contain HTML. Optional. */
    description : string;
    /** The (exclusive) end time of the event. For a recurring event, this is the end time of the first instance. */
    end : EventDateTime;
    /** Whether the end time is actually unspecified. An end time is still provided for compatibility reasons, even
if this attribute is set to True. The default is False. */
    endTimeUnspecified : boolean;
    /** ETag of the resource. */
    etag : string;
    /** Specific type of the event. This cannot be modified after the event is created. Possible values are:   -
"default" - A regular event or not further specified.  - "outOfOffice" - An out-of-office event.  -
"focusTime" - A focus-time event.  - "workingLocation" - A working location event.  Currently, only "default
" and "workingLocation" events can be created using the API. Extended support for other event types will be
made available in later releases. */
    eventType : string;
    /** Extended properties of the event. */
    extendedProperties : ExtendedPropertiesData;
    /** Focus Time event data. Used if eventType is focusTime. */
    focusTimeProperties : EventFocusTimeProperties;
    /** A gadget that extends this event. Gadgets are deprecated; this structure is instead only used for returning
birthday calendar metadata. */
    gadget : GadgetData;
    /** Whether attendees other than the organizer can invite others to the event. Optional. The default is True. */
    guestsCanInviteOthers : boolean;
    /** Whether attendees other than the organizer can modify the event. Optional. The default is False. */
    guestsCanModify : boolean;
    /** Whether attendees other than the organizer can see who the event's attendees are. Optional. The default is
True. */
    guestsCanSeeOtherGuests : boolean;
    /** An absolute link to the Google Hangout associated with this event. Read-only. */
    hangoutLink : string;
    /** An absolute link to this event in the Google Calendar Web UI. Read-only. */
    htmlLink : string;
    /** Event unique identifier as defined in RFC5545. It is used to uniquely identify events accross calendaring
systems and must be supplied when importing events via the import method. Note that the iCalUID and the id
are not identical and only one of them should be supplied at event creation time. One difference in their
semantics is that in recurring events, all occurrences of one event have different ids while they all share
the same iCalUIDs. To retrieve an event using its iCalUID, call the events.list method using the iCalUID
parameter. To retrieve an event using its id, call the events.get method. */
    iCalUID : string;
    /** Opaque identifier of the event. When creating new single or recurring events, you can specify their IDs.
Provided IDs must follow these rules:   - characters allowed in the ID are those used in base32hex encoding,
i.e. lowercase letters a-v and digits 0-9, see section 3.1.2 in RFC2938  - the length of the ID must be
between 5 and 1024 characters  - the ID must be unique per calendar  Due to the globally distributed nature
of the system, we cannot guarantee that ID collisions will be detected at event creation time. To minimize
the risk of collisions we recommend using an established UUID algorithm such as one described in RFC4122. If
you do not specify an ID, it will be automatically generated by the server. Note that the icalUID and the id
are not identical and only one of them should be supplied at event creation time. One difference in their
semantics is that in recurring events, all occurrences of one event have different ids while they all share
the same icalUIDs. */
    id : string;
    /** Type of the resource ("calendar#event"). */
    kind : string;
    /** Geographic location of the event as free-form text. Optional. */
    location : string;
    /** Whether this is a locked event copy where no changes can be made to the main event fields "summary",
"description", "location", "start", "end" or "recurrence". The default is False. Read-Only. */
    locked : boolean;
    /** The organizer of the event. If the organizer is also an attendee, this is indicated with a separate entry in
attendees with the organizer field set to True. To change the organizer, use the move operation. Read-only,
except when importing an event. */
    organizer : OrganizerData;
    /** For an instance of a recurring event, this is the time at which this event would start according to the
recurrence data in the recurring event identified by recurringEventId. It uniquely identifies the instance
within the recurring event series even if the instance was moved to a different time. Immutable. */
    originalStartTime : EventDateTime;
    /** Out of office event data. Used if eventType is outOfOffice. */
    outOfOfficeProperties : EventOutOfOfficeProperties;
    /** If set to True, Event propagation is disabled. Note that it is not the same thing as Private event
properties. Optional. Immutable. The default is False. */
    privateCopy : boolean;
    /** List of RRULE, EXRULE, RDATE and EXDATE lines for a recurring event, as specified in RFC5545. Note that
DTSTART and DTEND lines are not allowed in this field; event start and end times are specified in the start
and end fields. This field is omitted for single events or instances of recurring events. */
    recurrence : string[];
    /** For an instance of a recurring event, this is the id of the recurring event to which this instance belongs.
Immutable. */
    recurringEventId : string;
    /** Information about the event's reminders for the authenticated user. */
    reminders : RemindersData;
    /** Sequence number as per iCalendar. */
    sequence : number;
    /** Source from which the event was created. For example, a web page, an email message or any document
identifiable by an URL with HTTP or HTTPS scheme. Can only be seen or modified by the creator of the event. */
    source : SourceData;
    /** The (inclusive) start time of the event. For a recurring event, this is the start time of the first
instance. */
    start : EventDateTime;
    /** Status of the event. Optional. Possible values are:   - "confirmed" - The event is confirmed. This is the
default status.  - "tentative" - The event is tentatively confirmed.  - "cancelled" - The event is cancelled
(deleted). The list method returns cancelled events only on incremental sync (when syncToken or updatedMin
are specified) or if the showDeleted flag is set to true. The get method always returns them. A cancelled
status represents two different states depending on the event type:   - Cancelled exceptions of an
uncancelled recurring event indicate that this instance should no longer be presented to the user. Clients
should store these events for the lifetime of the parent recurring event. Cancelled exceptions are only
guaranteed to have values for the id, recurringEventId and originalStartTime fields populated. The other
fields might be empty.   - All other cancelled events represent deleted events. Clients should remove their
locally synced copies. Such cancelled events will eventually disappear, so do not rely on them being
available indefinitely. Deleted events are only guaranteed to have the id field populated.   On the
organizer's calendar, cancelled events continue to expose event details (summary, location, etc.) so that
they can be restored (undeleted). Similarly, the events to which the user was invited and that they manually
removed continue to provide details. However, incremental sync requests with showDeleted set to false will
not return these details. If an event changes its organizer (for example via the move operation) and the
original organizer is not on the attendee list, it will leave behind a cancelled event where only the id
field is guaranteed to be populated. */
    status : string;
    /** Title of the event. */
    summary : string;
    /** Whether the event blocks time on the calendar. Optional. Possible values are:   - "opaque" - Default value.
The event does block time on the calendar. This is equivalent to setting Show me as to Busy in the Calendar
UI.  - "transparent" - The event does not block time on the calendar. This is equivalent to setting Show me
as to Available in the Calendar UI. */
    transparency : string;
    /** Last modification time of the event (as a RFC3339 timestamp). Read-only. */
    updated : string;
    /** Visibility of the event. Optional. Possible values are:   - "default" - Uses the default visibility for
events on the calendar. This is the default value.  - "public" - The event is public and event details are
visible to all readers of the calendar.  - "private" - The event is private and only event attendees may
view event details.  - "confidential" - The event is private. This value is provided for compatibility
reasons. */
    visibility : string;
    /** Working location event data. */
    workingLocationProperties : EventWorkingLocationProperties;

    constructor() 
    {
    	            this.anyoneCanAddSelf = false ;
                this.attachments = [];
                this.attendees = [];
                this.attendeesOmitted = false ;
                this.colorId = "" ;
                this.conferenceData = new ConferenceData();
                this.created = "" ;
                this.creator = new CreatorData();
                this.description = "" ;
                this.end = new EventDateTime();
                this.endTimeUnspecified = false ;
                this.etag = "" ;
                this.eventType = "" ;
                this.extendedProperties = new ExtendedPropertiesData();
                this.focusTimeProperties = new EventFocusTimeProperties();
                this.gadget = new GadgetData();
                this.guestsCanInviteOthers = false ;
                this.guestsCanModify = false ;
                this.guestsCanSeeOtherGuests = false ;
                this.hangoutLink = "" ;
                this.htmlLink = "" ;
                this.iCalUID = "" ;
                this.id = "" ;
                this.kind = "" ;
                this.location = "" ;
                this.locked = false ;
                this.organizer = new OrganizerData();
                this.originalStartTime = new EventDateTime();
                this.outOfOfficeProperties = new EventOutOfOfficeProperties();
                this.privateCopy = false ;
                this.recurrence = [];
                this.recurringEventId = "" ;
                this.reminders = new RemindersData();
                this.sequence = null ;
                this.source = new SourceData();
                this.start = new EventDateTime();
                this.status = "" ;
                this.summary = "" ;
                this.transparency = "" ;
                this.updated = "" ;
                this.visibility = "" ;
                this.workingLocationProperties = new EventWorkingLocationProperties();
        }
}

export class EventAttachment {
    /** ID of the attached file. Read-only. For Google Drive files, this is the ID of the corresponding Files
resource entry in the Drive API. */
    fileId : string;
    /** URL link to the attachment. For adding Google Drive file attachments use the same format as in alternateLink
property of the Files resource in the Drive API. Required when adding an attachment. */
    fileUrl : string;
    /** URL link to the attachment's icon. This field can only be modified for custom third-party attachments. */
    iconLink : string;
    /** Internet media type (MIME type) of the attachment. */
    mimeType : string;
    /** Attachment title. */
    title : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.fileId = "" ;
                this.fileUrl = "" ;
                this.iconLink = "" ;
                this.mimeType = "" ;
                this.title = "" ;
                this.eTag = "" ;
        }
}

export class EventAttendee {
    /** Number of additional guests. Optional. The default is 0. */
    additionalGuests : number;
    /** The attendee's response comment. Optional. */
    comment : string;
    /** The attendee's name, if available. Optional. */
    displayName : string;
    /** The attendee's email address, if available. This field must be present when adding an attendee. It must be a
valid email address as per RFC5322. Required when adding an attendee. */
    email : string;
    /** The attendee's Profile ID, if available. */
    id : string;
    /** Whether this is an optional attendee. Optional. The default is False. */
    optional : boolean;
    /** Whether the attendee is the organizer of the event. Read-only. The default is False. */
    organizer : boolean;
    /** Whether the attendee is a resource. Can only be set when the attendee is added to the event for the first
time. Subsequent modifications are ignored. Optional. The default is False. */
    resource : boolean;
    /** The attendee's response status. Possible values are:   - "needsAction" - The attendee has not responded to
the invitation (recommended for new events).  - "declined" - The attendee has declined the invitation.  -
"tentative" - The attendee has tentatively accepted the invitation.  - "accepted" - The attendee has
accepted the invitation.  Warning: If you add an event using the values declined, tentative, or accepted,
attendees with the "Add invitations to my calendar" setting set to "When I respond to invitation in email"
won't see an event on their calendar unless they choose to change their invitation response in the event
invitation email. */
    responseStatus : string;
    /** Whether this entry represents the calendar on which this copy of the event appears. Read-only. The default
is False. */
    self : boolean;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.additionalGuests = null ;
                this.comment = "" ;
                this.displayName = "" ;
                this.email = "" ;
                this.id = "" ;
                this.optional = false ;
                this.organizer = false ;
                this.resource = false ;
                this.responseStatus = "" ;
                this.self = false ;
                this.eTag = "" ;
        }
}

export class ConferenceData {
    /** The ID of the conference. Can be used by developers to keep track of conferences, should not be displayed to
users. The ID value is formed differently for each conference solution type:   - eventHangout: ID is not
set. (This conference type is deprecated.) - eventNamedHangout: ID is the name of the Hangout. (This
conference type is deprecated.) - hangoutsMeet: ID is the 10-letter meeting code, for example aaa-bbbb-ccc.
- addOn: ID is defined by the third-party provider.  Optional. */
    conferenceId : string;
    /** The conference solution, such as Google Meet. Unset for a conference with a failed create request. Either
conferenceSolution and at least one entryPoint, or createRequest is required. */
    conferenceSolution : ConferenceSolution;
    /** A request to generate a new conference and attach it to the event. The data is generated asynchronously. To
see whether the data is present check the status field. Either conferenceSolution and at least one
entryPoint, or createRequest is required. */
    createRequest : CreateConferenceRequest;
    /** Information about individual conference entry points, such as URLs or phone numbers. All of them must belong
to the same conference. Either conferenceSolution and at least one entryPoint, or createRequest is required. */
    entryPoints : EntryPoint[];
    /** Additional notes (such as instructions from the domain administrator, legal notices) to display to the user.
Can contain HTML. The maximum length is 2048 characters. Optional. */
    notes : string;
    /** Additional properties related to a conference. An example would be a solution-specific setting for enabling
video streaming. */
    parameters : ConferenceParameters;
    /** The signature of the conference data. Generated on server side. Unset for a conference with a failed create
request. Optional for a conference with a pending create request. */
    signature : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.conferenceId = "" ;
                this.conferenceSolution = new ConferenceSolution();
                this.createRequest = new CreateConferenceRequest();
                this.entryPoints = [];
                this.notes = "" ;
                this.parameters = new ConferenceParameters();
                this.signature = "" ;
                this.eTag = "" ;
        }
}

export class ConferenceSolution {
    /** The user-visible icon for this solution. */
    iconUri : string;
    /** The key which can uniquely identify the conference solution for this event. */
    key : ConferenceSolutionKey;
    /** The user-visible name of this solution. Not localized. */
    name : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.iconUri = "" ;
                this.key = new ConferenceSolutionKey();
                this.name = "" ;
                this.eTag = "" ;
        }
}

export class ConferenceSolutionKey {
    /** The conference solution type. If a client encounters an unfamiliar or empty type, it should still be able to
display the entry points. However, it should disallow modifications. The possible values are:   -
"eventHangout" for Hangouts for consumers (deprecated; existing events may show this conference solution
type but new conferences cannot be created) - "eventNamedHangout" for classic Hangouts for Google Workspace
users (deprecated; existing events may show this conference solution type but new conferences cannot be
created) - "hangoutsMeet" for Google Meet (http://meet.google.com) - "addOn" for 3P conference providers */
    type : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.type = "" ;
                this.eTag = "" ;
        }
}

export class CreateConferenceRequest {
    /** The conference solution, such as Hangouts or Google Meet. */
    conferenceSolutionKey : ConferenceSolutionKey;
    /** The client-generated unique ID for this request. Clients should regenerate this ID for every new request. If
an ID provided is the same as for the previous request, the request is ignored. */
    requestId : string;
    /** The status of the conference create request. */
    status : ConferenceRequestStatus;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.conferenceSolutionKey = new ConferenceSolutionKey();
                this.requestId = "" ;
                this.status = new ConferenceRequestStatus();
                this.eTag = "" ;
        }
}

export class ConferenceRequestStatus {
    /** The current status of the conference create request. Read-only. The possible values are:   - "pending": the
conference create request is still being processed. - "success": the conference create request succeeded,
the entry points are populated. - "failure": the conference create request failed, there are no entry
points. */
    statusCode : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.statusCode = "" ;
                this.eTag = "" ;
        }
}

export class EntryPoint {
    /** The access code to access the conference. The maximum length is 128 characters. When creating new conference
data, populate only the subset of {meetingCode, accessCode, passcode, password, pin} fields that match the
terminology that the conference provider uses. Only the populated fields should be displayed. Optional. */
    accessCode : string;
    /** Features of the entry point, such as being toll or toll-free. One entry point can have multiple features.
However, toll and toll-free cannot be both set on the same entry point. */
    entryPointFeatures : string[];
    /** The type of the conference entry point. Possible values are:   - "video" - joining a conference over HTTP. A
conference can have zero or one video entry point. - "phone" - joining a conference by dialing a phone
number. A conference can have zero or more phone entry points. - "sip" - joining a conference over SIP. A
conference can have zero or one sip entry point. - "more" - further conference joining instructions, for
example additional phone numbers. A conference can have zero or one more entry point. A conference with only
a more entry point is not a valid conference. */
    entryPointType : string;
    /** The label for the URI. Visible to end users. Not localized. The maximum length is 512 characters. Examples:
 - for video: meet.google.com/aaa-bbbb-ccc - for phone: +1 123 268 2601 - for sip: 12345678@altostrat.com -
for more: should not be filled   Optional. */
    label : string;
    /** The meeting code to access the conference. The maximum length is 128 characters. When creating new
conference data, populate only the subset of {meetingCode, accessCode, passcode, password, pin} fields that
match the terminology that the conference provider uses. Only the populated fields should be displayed.
Optional. */
    meetingCode : string;
    /** The passcode to access the conference. The maximum length is 128 characters. When creating new conference
data, populate only the subset of {meetingCode, accessCode, passcode, password, pin} fields that match the
terminology that the conference provider uses. Only the populated fields should be displayed. */
    passcode : string;
    /** The password to access the conference. The maximum length is 128 characters. When creating new conference
data, populate only the subset of {meetingCode, accessCode, passcode, password, pin} fields that match the
terminology that the conference provider uses. Only the populated fields should be displayed. Optional. */
    password : string;
    /** The PIN to access the conference. The maximum length is 128 characters. When creating new conference data,
populate only the subset of {meetingCode, accessCode, passcode, password, pin} fields that match the
terminology that the conference provider uses. Only the populated fields should be displayed. Optional. */
    pin : string;
    /** The CLDR/ISO 3166 region code for the country associated with this phone access. Example: "SE" for Sweden.
Calendar backend will populate this field only for EntryPointType.PHONE. */
    regionCode : string;
    /** The URI of the entry point. The maximum length is 1300 characters. Format:   - for video, http: or https:
schema is required. - for phone, tel: schema is required. The URI should include the entire dial sequence
(e.g., tel:+12345678900,,,123456789;1234). - for sip, sip: schema is required, e.g.,
sip:12345678@myprovider.com. - for more, http: or https: schema is required. */
    uri : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.accessCode = "" ;
                this.entryPointFeatures = [];
                this.entryPointType = "" ;
                this.label = "" ;
                this.meetingCode = "" ;
                this.passcode = "" ;
                this.password = "" ;
                this.pin = "" ;
                this.regionCode = "" ;
                this.uri = "" ;
                this.eTag = "" ;
        }
}

export class ConferenceParameters {
    /** Additional add-on specific data. */
    addOnParameters : ConferenceParametersAddOnParameters;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.addOnParameters = new ConferenceParametersAddOnParameters();
                this.eTag = "" ;
        }
}

export class ConferenceParametersAddOnParameters {
    parameters : { [key: string]: string; };
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.parameters = {};
                this.eTag = "" ;
        }
}

export class CreatorData {
    /** The creator's name, if available. */
    displayName : string;
    /** The creator's email address, if available. */
    email : string;
    /** The creator's Profile ID, if available. */
    id : string;
    /** Whether the creator corresponds to the calendar on which this copy of the event appears. Read-only. The
default is False. */
    self : boolean;

    constructor() 
    {
    	            this.displayName = "" ;
                this.email = "" ;
                this.id = "" ;
                this.self = false ;
        }
}

export class EventDateTime {
    /** The date, in the format "yyyy-mm-dd", if this is an all-day event. */
    date : string;
    /** The time, as a combined date-time value (formatted according to RFC3339). A time zone offset is required
unless a time zone is explicitly specified in timeZone. */
    dateTime : string;
    /** The time zone in which the time is specified. (Formatted as an IANA Time Zone Database name, e.g.
"Europe/Zurich".) For recurring events this field is required and specifies the time zone in which the
recurrence is expanded. For single events this field is optional and indicates a custom time zone for the
event start/end. */
    timeZone : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.date = "" ;
                this.dateTime = "" ;
                this.timeZone = "" ;
                this.eTag = "" ;
        }
}

export class ExtendedPropertiesData {
    /** Properties that are private to the copy of the event that appears on this calendar. */
    private : { [key: string]: string; };
    /** Properties that are shared between copies of the event on other attendees' calendars. */
    shared : { [key: string]: string; };

    constructor() 
    {
    	            this.private = {};
                this.shared = {};
        }
}

export class EventFocusTimeProperties {
    /** Whether to decline meeting invitations which overlap Focus Time events. Valid values are declineNone,
meaning that no meeting invitations are declined; declineAllConflictingInvitations, meaning that all
conflicting meeting invitations that conflict with the event are declined; and
declineOnlyNewConflictingInvitations, meaning that only new conflicting meeting invitations which arrive
while the Focus Time event is present are to be declined. */
    autoDeclineMode : string;
    /** The status to mark the user in Chat and related products. This can be available or doNotDisturb. */
    chatStatus : string;
    /** Response message to set if an existing event or new invitation is automatically declined by Calendar. */
    declineMessage : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.autoDeclineMode = "" ;
                this.chatStatus = "" ;
                this.declineMessage = "" ;
                this.eTag = "" ;
        }
}

export class GadgetData {
    /** The gadget's display mode. Deprecated. Possible values are:   - "icon" - The gadget displays next to the
event's title in the calendar view.  - "chip" - The gadget displays when the event is clicked. */
    display : string;
    /** The gadget's height in pixels. The height must be an integer greater than 0. Optional. Deprecated. */
    height : number;
    /** The gadget's icon URL. The URL scheme must be HTTPS. Deprecated. */
    iconLink : string;
    /** The gadget's URL. The URL scheme must be HTTPS. Deprecated. */
    link : string;
    /** Preferences. */
    preferences : { [key: string]: string; };
    /** The gadget's title. Deprecated. */
    title : string;
    /** The gadget's type. Deprecated. */
    type : string;
    /** The gadget's width in pixels. The width must be an integer greater than 0. Optional. Deprecated. */
    width : number;

    constructor() 
    {
    	            this.display = "" ;
                this.height = null ;
                this.iconLink = "" ;
                this.link = "" ;
                this.preferences = {};
                this.title = "" ;
                this.type = "" ;
                this.width = null ;
        }
}

export class OrganizerData {
    /** The organizer's name, if available. */
    displayName : string;
    /** The organizer's email address, if available. It must be a valid email address as per RFC5322. */
    email : string;
    /** The organizer's Profile ID, if available. */
    id : string;
    /** Whether the organizer corresponds to the calendar on which this copy of the event appears. Read-only.
The default is False. */
    self : boolean;

    constructor() 
    {
    	            this.displayName = "" ;
                this.email = "" ;
                this.id = "" ;
                this.self = false ;
        }
}

export class EventOutOfOfficeProperties {
    /** Whether to decline meeting invitations which overlap Out of office events. Valid values are declineNone,
meaning that no meeting invitations are declined; declineAllConflictingInvitations, meaning that all
conflicting meeting invitations that conflict with the event are declined; and
declineOnlyNewConflictingInvitations, meaning that only new conflicting meeting invitations which arrive
while the Out of office event is present are to be declined. */
    autoDeclineMode : string;
    /** Response message to set if an existing event or new invitation is automatically declined by Calendar. */
    declineMessage : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.autoDeclineMode = "" ;
                this.declineMessage = "" ;
                this.eTag = "" ;
        }
}

export class RemindersData {
    /** If the event doesn't use the default reminders, this lists the reminders specific to the event, or, if
not set, indicates that no reminders are set for this event. The maximum number of override reminders is
5. */
    overrides : EventReminder[];
    /** Whether the default reminders of the calendar apply to the event. */
    useDefault : boolean;

    constructor() 
    {
    	            this.overrides = [];
                this.useDefault = false ;
        }
}

export class EventReminder {
    /** The method used by this reminder. Possible values are:   - "email" - Reminders are sent via email.  -
"popup" - Reminders are sent via a UI popup.   Required when adding a reminder. */
    method : string;
    /** Number of minutes before the start of the event when the reminder should trigger. Valid values are between 0
and 40320 (4 weeks in minutes). Required when adding a reminder. */
    minutes : number;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.method = "" ;
                this.minutes = null ;
                this.eTag = "" ;
        }
}

export class SourceData {
    /** Title of the source; for example a title of a web page or an email subject. */
    title : string;
    /** URL of the source pointing to a resource. The URL scheme must be HTTP or HTTPS. */
    url : string;

    constructor() 
    {
    	            this.title = "" ;
                this.url = "" ;
        }
}

export class EventWorkingLocationProperties {
    /** If present, specifies that the user is working from a custom location. */
    customLocation : CustomLocationData;
    /** If present, specifies that the user is working at home. */
    homeOffice : any;
    /** If present, specifies that the user is working from an office. */
    officeLocation : OfficeLocationData;
    /** Type of the working location. Possible values are:   - "homeOffice" - The user is working at home.  -
"officeLocation" - The user is working from an office.  - "customLocation" - The user is working from a
custom location.  Any details are specified in a sub-field of the specified name, but this field may be
missing if empty. Any other fields are ignored. Required when adding working location properties. */
    type : string;
    /** The ETag of the item. */
    eTag : string;

    constructor() 
    {
    	            this.customLocation = new CustomLocationData();
                this.homeOffice = null;
                this.officeLocation = new OfficeLocationData();
                this.type = "" ;
                this.eTag = "" ;
        }
}

export class CustomLocationData {
    /** An optional extra label for additional information. */
    label : string;

    constructor() 
    {
    	            this.label = "" ;
        }
}

export class OfficeLocationData {
    /** An optional building identifier. This should reference a building ID in the organization's Resources
database. */
    buildingId : string;
    /** An optional desk identifier. */
    deskId : string;
    /** An optional floor identifier. */
    floorId : string;
    /** An optional floor section identifier. */
    floorSectionId : string;
    /** The office name that's displayed in Calendar Web and Mobile clients. We recommend you reference a
building name in the organization's Resources database. */
    label : string;

    constructor() 
    {
    	            this.buildingId = "" ;
                this.deskId = "" ;
                this.floorId = "" ;
                this.floorSectionId = "" ;
                this.label = "" ;
        }
}

export class MarketplaceActivation extends BaseEntity {
    userSecret : string;
    apiToken : string;
    apiClaim : string;
    userId : string;
    customerWebId : string;

    constructor() 
    {
    	        super();
		            this.userSecret = "" ;
                this.apiToken = "" ;
                this.apiClaim = "" ;
                this.userId = "" ;
                this.customerWebId = "" ;
        }
}

export class GoogleGroupUsersPair {
    googleName : string;
    googleEmails : string[];

    constructor() 
    {
    	            this.googleName = "" ;
                this.googleEmails = [];
        }
}

export class GoogleEventWithCalendar extends Event {

    constructor() 
    {
    	        super();
		    }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class LoginResponse {
    userId : string;
    isAdmin : boolean;
    webUserId : string;
    username : string;
    token : string;

    constructor() 
    {
    	            this.userId = "" ;
                this.isAdmin = false ;
                this.webUserId = "" ;
                this.username = "" ;
                this.token = "" ;
        }
}

export class GetGroupsResponse {
    onOfficeGroupId : number;
    onOfficeName : string;
    onOfficeUserIds : number[];

    constructor() 
    {
    	            this.onOfficeGroupId = null ;
                this.onOfficeName = "" ;
                this.onOfficeUserIds = [];
        }
}

export class UserWithAuthStatus {
    identifier : string;
    firstname : string;
    lastname : string;
    email : string;
    username : string;
    googleEmail : string;
    googleAuthDone : boolean;
    isSyncActive : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.firstname = "" ;
                this.lastname = "" ;
                this.email = "" ;
                this.username = "" ;
                this.googleEmail = "" ;
                this.googleAuthDone = false ;
                this.isSyncActive = false ;
        }
}

export class SyncError extends BaseEntity {
    onOfficeUserIds : OnOfficeUserIds;
    eventIdPair : EventIdPair;
    exceptionJson : string;
    message : string;
    dismissed : boolean;

    constructor() 
    {
    	        super();
		            this.onOfficeUserIds = new OnOfficeUserIds();
                this.eventIdPair = new EventIdPair();
                this.exceptionJson = "" ;
                this.message = "" ;
                this.dismissed = false ;
        }
}

export class FirstSyncVm {
    usernames : string[];
    startDate : string ;
    endDate : string ;
    webUserId : string;

    constructor() 
    {
    	            this.usernames = [];
                this.startDate = null;
                this.endDate = null;
                this.webUserId = "" ;
        }
}

export class User extends BaseEntity {
    userIds : OnOfficeUserIds;
    googleAuthData : GoogleAuthorizationResponse;
    calendarsToSync : NameId[];
    hasRevokedAuth : boolean;
    isSyncEnabled : boolean;
    lastSyncedOn : string ;

    constructor() 
    {
    	        super();
		            this.userIds = new OnOfficeUserIds();
                this.googleAuthData = new GoogleAuthorizationResponse();
                this.calendarsToSync = [];
                this.hasRevokedAuth = false ;
                this.isSyncEnabled = false ;
                this.lastSyncedOn = null;
        }
}

export class GoogleAuthorizationResponse {
    access_token : string;
    refresh_token : string;
    expires_in : number;
    scope : string;
    token_type : string;
    id_token : string;
    googleEmail : string;

    constructor() 
    {
    	            this.access_token = "" ;
                this.refresh_token = "" ;
                this.expires_in = null ;
                this.scope = "" ;
                this.token_type = "" ;
                this.id_token = "" ;
                this.googleEmail = "" ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}